import type { AnimationProperties, AnimationsKit } from '../../types';

const name = 'CrossFade';
const properties: AnimationProperties = {
  defaultDuration: 0.6,
  schema: {
    duration: {
      type: 'number',
      min: 0,
      default: 0,
    },
    delay: {
      type: 'number',
      min: 0,
      default: 0,
    },
    stagger: {
      type: 'number',
      default: 0,
    },
  },
};

/**
 * CrossFade between two elements, animation the source from 1 to 0 opacity while animating the destination from 0 to 1.
 */
function transition(
  kit: AnimationsKit,
  sourceElements: HTMLElement[] | HTMLElement | HTMLCollection,
  destElements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration?: number,
  delay?: number,
  {
    stagger = 0,
    sourceEase = 'Sine.easeInOut',
    destEase = 'Sine.easeInOut',
    ...params
  }: any = {},
) {
  const sequence = kit.sequence(params);
  sequence.add([
    kit.animate('BaseFade', sourceElements, duration, delay, {
      from: { opacity: 1 },
      to: { opacity: 0 },
      ease: sourceEase,
      stagger,
    }),
    kit.animate('BaseFade', destElements, duration, delay, {
      from: { opacity: 0 },
      to: { opacity: 1 },
      ease: destEase,
      stagger,
    }),
  ]);

  return sequence.get();
}

export { name, properties, transition };
